import AccountSecurityOptionFull from './components/AccountSecurityOptionFull';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var AccountSecurityOption = {
    key: 'accountSecurity',
    titleStringKey: 'options_premium_subTitleAccountSecurity',
    searchTermsStringKey: 'options_premium_subTitleAccountSecurity',
    hideTitleInFullOptions: false,
    fullOptionFormSettings: {
        render: function () { return React.createElement(AccountSecurityOptionFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return !isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
    },
};
export default AccountSecurityOption;
//# sourceMappingURL=AccountSecurityOption.js.map